import script from "./StepBenefits.vue?vue&type=script&setup=true&lang=js"
export * from "./StepBenefits.vue?vue&type=script&setup=true&lang=js"

import "./StepBenefits.vue?vue&type=style&index=0&id=712a5139&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-712a5139"]])

export default __exports__